export default {"src":"/uk/_next/static/media/planning-icon-yellow.61612035.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};